import { render, staticRenderFns } from "./invoices-new.vue?vue&type=template&id=04820099&scoped=true&"
import script from "./invoices-new.vue?vue&type=script&lang=ts&"
export * from "./invoices-new.vue?vue&type=script&lang=ts&"
import style0 from "./invoices-new.vue?vue&type=style&index=0&id=04820099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04820099",
  null
  
)

export default component.exports